import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Config } from "../../Config";
import { ClipboardCheck, Home, LockKeyhole, TriangleAlert } from "lucide-react";
import { can_visit, setSecureData } from "../../helpers";
import { useDocumentTitle } from "../../hooks/customDocumentTitleHook";
import { getAccessToken } from "../../Session";

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const admin_routes = Config.adminRoutes;
  const routeExists = admin_routes.includes(location.pathname);
  const [showContent, setShowContent] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(async () => {
      const token = getAccessToken();

      if (!token) {
        const excludedPaths = ["/", "/no-practices-found"];
        const currentPath = window.location.pathname;

        if (!excludedPaths.includes(currentPath)) {
          await setSecureData("redirect", currentPath + window.location.search);
        }
        navigate("/login", { replace: true });
        return;
      }

      setShowContent(false);
    }, 1000);

    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useDocumentTitle("");

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
      }}
    >
      {showContent ? 
        <>
          <div>Loading...</div>
        </>
      :
        <>
          {routeExists ? 
            <>
              <h1 style={{ color: "#f4ae0f" }}><LockKeyhole height={75} width={75} /></h1>
              <br />
              <p style={{ fontSize: "1.5rem", color: "#666" }}>401 - UNAUTHORIZED ACCESS</p>
              <p style={{ color: "#666" }}>You do not have permission to access the requested page</p>
            </>
          : 
            can_visit("_role_trial") ?
              <>
                <h1 style={{ color: "#0880ea" }}><ClipboardCheck height={75} width={75} /></h1>
                <br />
                <p style={{ fontSize: "1.5rem", color: "#666" }}>401 - AUDIT IN PROGRESS</p>
                <p style={{ color: "#666" }}>The audit process is still ongoing. Please wait while we complete the verification of your practice.</p>
              </>
            :
              <>
                <h1 style={{ color: "#f93137" }}><TriangleAlert height={75} width={75} /></h1>
                <br />
                <p style={{ fontSize: "1.5rem", color: "#666" }}>404 - PAGE NOT FOUND</p>
                <p style={{ color: "#666" }}>Sorry, the page you're looking for doesn't exist.</p>
              </>
          }
          <br />
          <Link to="/">
            <button
              className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn size_lg"
            >
              <Home width={15} height={15} />
              <span>Home</span>
            </button>
          </Link>
        </>
      }
    </div>
  );
};

export default NotFound;
